import SimpleArtist from '@common/types/artist/simple-artist';
import { SimpleOnboarding } from '@common/types/artist-onboarding/simple-onboarding';

import { CallApi, handleJSONResponse } from './common';
import { ArtistRelation } from '@common/types/artist/artist-relation';

const callAPI = CallApi('onboarding');

export const create = async (
  profile: SimpleArtist,
  role: ArtistRelation['role']
): Promise<SimpleOnboarding> => {
  const response = await callAPI('/', 'POST', { profile, role });

  return await handleJSONResponse(response);
};
